import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AsmRootModule, ASM_FEATURE } from '@spartacus/asm/root';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { AsmMainUiComponent } from './asm-main-ui/asm-main-ui.component';

@NgModule({
  declarations: [AsmMainUiComponent],
  imports: [CommonModule, I18nModule, MatIconModule, AsmRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SalesRepInfoFlexType: {
          component: AsmMainUiComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
      featureModules: {
        [ASM_FEATURE]: {
          module: () => import('@spartacus/asm').then((m) => m.AsmModule),
        },
      },
    }),
  ],
  exports: [AsmMainUiComponent],
})
export class AsmModule {}
